export default function updateDiscountReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_DISCOUNT_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_DISCOUNT_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_DISCOUNT_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}